import { Action } from 'redux';

import { isSetCustomDomainEnabledAction } from '../actions/SetCustomDomainEnabledAction';


export function customDomainEnabledReducer(
    previousState: boolean = true,
    action: Action = null
): boolean {
    if (isSetCustomDomainEnabledAction(action)) {
        return action.customDomainEnabled;
    } else {
        return previousState;
    }
}
